var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "variant-selection-wrapper" }, [
    _c("div", { staticClass: "d-flex flex-column" }, [
      _c("span", [
        _c("strong", [_vm._v(" Template Product: ")]),
        _vm._v(
          "\n            " +
            _vm._s(_vm.templateProduct.templateProductName) +
            "\n        "
        ),
      ]),
      _vm._v(" "),
      _c("span", [
        _c("strong", [_vm._v(" POD Product: ")]),
        _vm._v(
          "\n            " + _vm._s(_vm.selectedProduct.title) + "\n        "
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("Choose a product variant and assign a POD variant to it."),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex justify-content-end align-items-center mb-2" },
      [
        _c("strong", [_vm._v("Wholesale Price")]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [{ name: "tippy", rawName: "v-tippy" }],
            staticClass: "ml-1",
            attrs: {
              content: "Copy first variant's price to all other variants",
            },
          },
          [
            _c(
              "button",
              {
                staticClass: "btn-sm",
                on: { click: _setup.copyFirstPriceToAll },
              },
              [_c("i", { staticClass: "fa fa-copy mr-1" })]
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "list-group" },
      _vm._l(_vm.templateProduct.variants, function (variant, idx) {
        return _c(
          "li",
          {
            key: `variant-${idx}-${variant.id}`,
            staticClass:
              "list-group-item d-flex align-items-center justify-content-between",
            attrs: { id: `variant-${idx}-${variant.id}` },
          },
          [
            _c("span", { staticClass: "badge badge-customily" }, [
              _vm._v(
                "\n                " + _vm._s(variant.title) + "\n            "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [{ name: "tippy", rawName: "v-tippy" }],
                staticClass: "fulfillment-container",
                attrs: { content: variant.podVariantName || variant.title },
              },
              [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-turquise",
                      on: {
                        click: function ($event) {
                          return _setup.selectVariant(
                            variant,
                            `variant-${idx}-${variant.id}`
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                        Provider Variant\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  variant.podVariantId
                    ? _c(
                        "div",
                        { staticClass: "form-control fulfillment-input ml-3" },
                        [
                          _c("span", { staticClass: "fulfillment-text" }, [
                            _vm._v(
                              _vm._s(
                                variant.podVariantName ||
                                  "Assigned to a different product"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "remove-fulfillment-icon",
                              on: {
                                click: function ($event) {
                                  return _setup.removeVariantSelection(variant)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fa fa-times-circle" })]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "price-input-container d-flex flex-column justify-content-center ml-3",
                    },
                    [
                      _c("b-form-input", {
                        staticStyle: { width: "80px" },
                        attrs: { type: "number", min: "0", size: "sm" },
                        model: {
                          value: variant.wholesalePrice,
                          callback: function ($$v) {
                            _vm.$set(variant, "wholesalePrice", $$v)
                          },
                          expression: "variant.wholesalePrice",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }